/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const PerformanceFacts = styled.section`
  border: 1px solid black;
  width: 370px;
  padding: 0.5rem;
  font-size: small;
  line-height: 1.4;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: 2rem;
  margin: 0 0 0.25rem 0;
`;

const Header = styled.header`
  border-bottom: 10px solid black;
  padding: 0 0 0.25rem 0;
  margin: 0 0 0.5rem 0;
  p {
    margin: 0;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead tr th,
  thead tr td {
    border: 0;
  }

  th,
  td {
    font-weight: normal;
    text-align: left;
    padding: 0.25rem 0;
    border-top: 1px solid black;
    white-space: nowrap;
  }

  td:last-child {
    text-align: right;
  }

  .blank-cell {
    width: 1rem;
    border-top: 0;
  }

  .thick-row th,
  .thick-row td {
    border-top-width: 5px;
  }

  .thick-end {
    border-bottom: 10px solid black;
  }

  .thin-end {
    border-bottom: 1px solid black;
  }
`;

const SmallInfo = styled.p`
  font-size: 0.7rem;
  margin: 0;
`;

const GridTable = styled(Table)`
  margin: 0 0 0.5rem 0;
  td:last-child {
    text-align: left;
    &::before {
      content: "•";
      font-weight: bold;
      margin: 0 0.25rem 0 0;
    }
  }
`;

const SmallTable = styled(Table)`
  border-bottom: 1px solid #999;
  margin: 0 0 0.5rem 0;

  thead tr {
    border-bottom: 1px solid black;
  }

  td:last-child {
    text-align: left;
  }

  th,
  td {
    border: 0;
    padding: 0;
  }
`;

const TextCenter = styled.p`
  text-align: center;
  margin: 0;
`;

const NutritionLabel = ({ nutritionData }) => {
  const {
    servingSize = "1/2 cup (about 82g)",
    servingsPerContainer = "8",
    calories = "200",
    caloriesFromFat = "130",
    totalFat = "14g",
    saturatedFat = "9g",
    transFat = "0g",
    cholesterol = "55mg",
    sodium = "40mg",
    totalCarbs = "17g",
    dietaryFiber = "1g",
    sugars = "14g",
    protein = "3g",
    vitaminA = "10%",
    vitaminC = "0%",
    calcium = "10%",
    iron = "6%",
  } = nutritionData || {};

  return (
    <PerformanceFacts>
      <Header>
        <Title>Live Nutrition Facts</Title>
        <p>Serving Size {servingSize}</p>
        <p>Servings Per Container {servingsPerContainer}</p>
      </Header>

      <Table>
        <thead>
          <tr>
            <th colSpan="3" style={{ fontSize: "0.7rem" }}>
              Amount Per Serving
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colSpan="2">
              <b>Calories</b> {calories}
            </th>
            <td>Calories from Fat {caloriesFromFat}</td>
          </tr>
          <tr className="thick-row">
            <td colSpan="3" style={{ fontSize: "0.7rem" }}>
              <b>% Daily Value*</b>
            </td>
          </tr>
          <tr>
            <th colSpan="2">
              <b>Total Fat</b> <span style={{ color: "black", fontSize: "20px" }}>{totalFat}</span>
            </th>
            <td>
              <b>
                {totalFat === "0.0g" ? "0%" : `${((parseFloat(totalFat) / 69) * 100).toFixed(1)}%`}
              </b>
            </td>
          </tr>
          <tr>
            <td className="blank-cell"></td>
            <th>Saturated Fat {saturatedFat}</th>
            <td>
              {saturatedFat === "0.0g"
                ? "0%"
                : `${((parseFloat(saturatedFat) / 25) * 100).toFixed(1)}%`}
            </td>
          </tr>
          <tr>
            <th colSpan="2">
              <b>Cholesterol</b> {cholesterol}
            </th>
            <td></td>
          </tr>
          <tr>
            <th colSpan="2">
              <b>Sodium</b> {sodium}
            </th>
            <td>
              <b>
                {sodium === "0.0g" ? "0%" : `${((parseFloat(sodium) / 2300) * 100).toFixed(1)}%`}
              </b>
            </td>
          </tr>
          <tr>
            <th colSpan="2">
              <b>Total Carbohydrate</b>{" "}
              <span style={{ color: "black", fontSize: "20px" }}> {totalCarbs} </span>
            </th>
            <td>
              <b>
                {totalCarbs === "0.0g"
                  ? "0%"
                  : `${((parseFloat(totalCarbs) / 300) * 100).toFixed(1)}%`}
              </b>
            </td>
          </tr>
          <tr>
            <td className="blank-cell"></td>
            <th>Dietary Fiber {dietaryFiber}</th>
            <td>
              <b>
                {dietaryFiber === "0.0g"
                  ? "0%"
                  : `${((parseFloat(dietaryFiber) / 30) * 100).toFixed(1)}%`}
              </b>
            </td>
          </tr>
          <tr>
            <td className="blank-cell"></td>
            <th>Sugars {sugars}</th>
            <td></td>
          </tr>
          <tr className="">
            <th colSpan="2">
              <b>Protein</b> <span style={{ color: "black", fontSize: "20px" }}>{protein}</span>
            </th>
            <td></td>
          </tr>
        </tbody>
      </Table>
      {/* 
      <GridTable>
        <tbody>
          <tr>
            <td colSpan="2">Vitamin A {vitaminA}</td>
            <td>Vitamin C {vitaminC}</td>
          </tr>
          <tr className="thin-end">
            <td colSpan="2">Calcium {calcium}</td>
            <td>Iron {iron}</td>
          </tr>
        </tbody>
      </GridTable>

      <SmallInfo>* Percent Daily Values are based on a 2,000 calorie diet.</SmallInfo>

      <SmallInfo style={{ marginTop: "10px" }}>Calories per gram:</SmallInfo>
      <TextCenter style={{ fontSize: "0.7rem" }}>Fat 9 • Carbohydrate 4 • Protein 4</TextCenter>
      */}
    </PerformanceFacts>
  );
};

NutritionLabel.propTypes = {
  nutritionData: PropTypes.shape({
    servingSize: PropTypes.string,
    servingsPerContainer: PropTypes.string,
    calories: PropTypes.string,
    caloriesFromFat: PropTypes.string,
    totalFat: PropTypes.string,
    saturatedFat: PropTypes.string,
    transFat: PropTypes.string,
    cholesterol: PropTypes.string,
    sodium: PropTypes.string,
    totalCarbs: PropTypes.string,
    dietaryFiber: PropTypes.string,
    sugars: PropTypes.string,
    protein: PropTypes.string,
    vitaminA: PropTypes.string,
    vitaminC: PropTypes.string,
    calcium: PropTypes.string,
    iron: PropTypes.string,
  }),
};

export default NutritionLabel;
